import { createAction } from 'ducks/helpers';
import constants from './constants';

export const userManualRequest = createAction(`${constants.userManuals}_REQUEST`);
export const userManualSuccess = createAction(`${constants.userManuals}_SUCCESS`);
export const userManualFailure = createAction(`${constants.userManuals}_FAILURE`);

export const setIsLoading = createAction(`${constants.userManuals}_SET_IS_LOADING`);
export const setSelected = createAction(`${constants.userManuals}_SET_SELECTED`);